import { render, staticRenderFns } from "./ThemeColorSettings.vue?vue&type=template&id=20856796"
import script from "./ThemeColorSettings.vue?vue&type=script&lang=js"
export * from "./ThemeColorSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports